// Copyright (c) Move Closer 2022.

import { WindowService } from '@movecloser/front-core'
import { Context } from '../../../shared/contracts/context'

export const SESSION_COOKIE_KEY = 'x-session'

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export function loadSessionCookie (context: Context): string | null {
  let cookies
  let sessionToken = null

  if (context.ssr || !WindowService.isDefined) {
    cookies = context.ssr?.req.headers.cookie ?? ''
  } else {
    cookies = document.cookie
  }

  const sessionCookie = cookies.split('; ').find((c) => c.startsWith(SESSION_COOKIE_KEY))

  if (sessionCookie) {
    sessionToken = sessionCookie.split('=')[1]
  }

  return sessionToken
}
